import { render } from "./Form.vue?vue&type=template&id=022b4160&scoped=true"
import script from "./Form.vue?vue&type=script&lang=ts"
export * from "./Form.vue?vue&type=script&lang=ts"

import "./Form.vue?vue&type=style&index=0&id=022b4160&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-022b4160"

export default script